import { Paper, Container, Grid, Modal } from "@material-ui/core"
import { LoginIndicator } from "components/LoginIndicator"
import React, { FC, useState } from "react"

import { renderErrorOrLoading } from "../commons/renderErrorOrLoading"
import { MatchupView } from "../components/MatchupView"
import { Standings } from "../components/Standings"
import { Matchup } from "../data/types"
import { useData } from "../data/useData"
import { useUser } from "../data/useUser"
import { ResultsDialog } from "./ResultsDialog"
import { UserDialog } from "./UserDialog"
import { Rules } from "./Rules"
interface Props{
  startTime: number
  isOlympics: boolean
}
export const Main = ({isOlympics, startTime}: Props) => {
  const { matchups, loading, error } = useData()

  const [matchup, setMatchup] = useState<Matchup>()
  const [rules, setRules] = useState(false)
  const { user, setUser } = useUser()
  const errorOrLoading = renderErrorOrLoading({ loading, error })
  if (errorOrLoading) return errorOrLoading
  return (
    <Container>
      <LoginIndicator showRules={()=>setRules(true)}/>
      <Grid container spacing={4} justify={"space-evenly"}>
        <Grid item key={"standings"} xs={12}>
          <Standings />
        </Grid>
        {matchups &&
          matchups.map((v, i) => (
            <Grid item key={i}>
              <MatchupView {...v} onOpen={() => setMatchup(v)} />
            </Grid>
          ))}
      </Grid>
      <Modal
        open={!!matchup}
        onClose={() => setMatchup(undefined)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <ResultsDialog {...{ matchup }} onClose={() => setMatchup(undefined)} />
      </Modal>
      <Modal open={!user} onClose={() => setUser("GUEST")}>
        <UserDialog onSetUser={setUser} />
      </Modal>
      <Modal open={rules} onClose={() => setRules(false)}>
        <Paper
          elevation={3}
          style={{ padding: 10, minHeight: 200, minWidth: 200 }}
        >
          <Rules startTime={startTime} isOlympics={isOlympics}/>
        </Paper>
      </Modal>
    </Container>
  )
}
